import React, { useState } from 'react'

// redux
import { connect } from "react-redux";

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// styles
import {
    HeaderSearchContainer
} from '../../styles/HeaderStyles'

// icons
import { MdLogout } from "react-icons/md";
import { HiUser, HiShoppingCart, HiUserAdd } from "react-icons/hi";

// react router
import { Link } from "react-router-dom";

// helpers | common
import {
    globalLogout,
} from "utlis/helpers/Common/CommonHelperFunctions";

// logo
import stLogo from 'assets/images/logo.png'

// components
import Search from './Search';

function HeaderContent(props) {
    // props
    const {
        cartDetails,
        currentUser,

        setMobileMenuVisibility,
    } = props

    // states
    const [isDropdownOpened, setIsDropdownOpened] = useState(false)

    // user logouts
    const handleUserLogout = ev => {
        ev.preventDefault()

        const confirm = window.confirm("Are you sure you want to logout?")

        if (confirm) {
            // enable global loading
            setGlobalLoading(true)

            // global logout function
            globalLogout()

            // disabling global loading
            setGlobalLoading(true)
        }
    }

    return (
        <div className="main-sec d-flex flex-wrap align-items-center">
            {/* left sec */}
            <div className="lt-sec media-body pe-2 pe-lg-3">
                <div className="inner">
                    <HeaderSearchContainer className="position-relative">
                        <Search setMobileMenuVisibility={setMobileMenuVisibility} />
                    </HeaderSearchContainer>
                </div>
            </div>

            {/* center sec */}
            <div className="ct-sec">
                <div className="inner">
                    <Link to="/" className="text-decoration-none d-block cursor-pointer">
                        <img src={stLogo} alt="logo" className="img-fluid" />
                    </Link>
                </div>
            </div>

            {/* right sec */}
            <div className="rt-sec media-body ps-2 ps-lg-3">
                <div className="inner d-flex align-items-center justify-content-end">
                    {
                        currentUser?.firstName ? ( // if the user is logged in
                            // link
                            <div
                                className="sign-in-link position-relative d-flex align-items-center"
                                onMouseEnter={() => setIsDropdownOpened(true)}
                                onMouseLeave={() => setIsDropdownOpened(false)}>
                                <Link to="/account" className="d-flex flex-column align-items-center text-decoration-none" onClick={ev => ev.preventDefault()}>
                                    <HiUser className="st-fs-20" />

                                    <span className="position-relative sign-in-label">
                                        Welcome <span className="st-fw-600">{currentUser?.firstName}</span>
                                    </span>
                                </Link>

                                {
                                    /* dropdown menu */
                                    isDropdownOpened ? (
                                        <React.Fragment>
                                            <div className="st-dropdown-menu">
                                                <div className="inner">
                                                    <Link to="/account" className="dm-link text-decoration-none d-flex align-items-center" onClick={() => setIsDropdownOpened(false)}>
                                                        <HiUser className="st-fs-13" />
                                                        <span className="ms-2 st-fs-13 st-fw-600">My Account</span>
                                                    </Link>

                                                    <a href="/" className="dm-link text-decoration-none d-flex align-items-center" onClick={handleUserLogout}>
                                                        <MdLogout className="st-fs-14" />
                                                        <span className="ms-2 st-fs-13 st-fw-600">Logout</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ) : null
                                }
                            </div>
                        ) : ( // if the user is not logged in
                            // link
                            <div
                                className="sign-in-link position-relative d-flex align-items-center"
                                onMouseEnter={() => setIsDropdownOpened(true)}
                                onMouseLeave={() => setIsDropdownOpened(false)}>
                                <Link to="/" className="d-flex flex-column align-items-center text-decoration-none" onClick={ev => ev.preventDefault()}>
                                    <HiUser className="st-fs-20" />

                                    <span className="position-relative sign-in-label">
                                        Sign In
                                    </span>
                                </Link>

                                {
                                    /* dropdown menu */
                                    isDropdownOpened ? (
                                        <React.Fragment>
                                            <div className="st-dropdown-menu">
                                                <div className="inner">
                                                    {/* link */}
                                                    <Link to="/login" className="dm-link text-decoration-none d-flex align-items-center" onClick={() => setIsDropdownOpened(false)}>
                                                        <HiUser fontSize={16} />
                                                        <span className="ms-2 st-fs-13 st-fw-600">Sign In</span>
                                                    </Link>
                                                    {/* link */}
                                                    <Link to="/register" className="dm-link text-decoration-none d-flex align-items-center" onClick={() => setIsDropdownOpened(false)}>
                                                        <HiUserAdd fontSize={17} />
                                                        <span className="ms-2 st-fs-13 st-fw-600">Register</span>
                                                    </Link>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    ) : null
                                }
                            </div>
                        )
                    }

                    {/* link */}
                    <div className="sign-in-link position-relative d-flex align-items-center">
                        <Link to="/cart" className="d-flex flex-column align-items-center text-decoration-none">
                            <HiShoppingCart className="st-fs-20" />

                            <span className="position-relative sign-in-label">
                                Cart ({cartDetails?.cart_qty ?? 0})
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}


const getDataFromStore = (state) => {
    return {
        cartDetails: state.cart.cartDetails,
        currentUser: state.auth.currentUser,
    };
};

const dispatchActionsToProps = (dispatch) => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    };
};

export default connect(getDataFromStore, dispatchActionsToProps)(HeaderContent);